import StepBanner from '@modules/Account/Profile/components/ProfileBanner/StepBanner';
import { useContext, useState } from 'react';
import { ProfileContext } from '../../../AccountProfile';
import { useDeleteProfileEntry } from '../../../hooks/useDeleteProfileEntry';
import ProfileMainSection from '../../ResumeSection';
import UpcomingExamsCard from './UpcomingExamsCard';
import UpcomingExamsForm from './UpcomingExamsForm';
import SkeletonBox from '@components/V4/SkeletonBox';
import { UserExamWithName } from '@shared/clientTypes/DTOs/UserDTO';

export interface ExamsCardProps {
  userId: string;
  exam: UserExamWithName;
  onDeleteEntry: (id: string | undefined) => void;
}

interface UpcomingExamsSectionProps {
  exams: UserExamWithName[];
  userId: string;
}

const UpcomingExamsSection = (props: UpcomingExamsSectionProps) => {
  const { exams, userId } = props;

  const { isMentorViewer, isLoading } = useContext(ProfileContext);

  const [isAddNewItem, setIsAddNewItem] = useState(false);

  const [deleteEntryHandler] = useDeleteProfileEntry({
    userId,
    profileProperty: 'exams',
  });

  const addNewItemCancelHandler = () => {
    setIsAddNewItem(false);
  };

  return (
    <ProfileMainSection
      title="Upcoming Exams"
      onClick={() => setIsAddNewItem((prev) => !prev)}
      isButtonActive={isAddNewItem}
    >
      {isLoading ? (
        <SkeletonBox className="w-full h-[78px]" />
      ) : (
        <>
          {isAddNewItem && (
            <UpcomingExamsForm
              userId={userId}
              isModeAddNew
              setIsAddNewItem={setIsAddNewItem}
              onCancel={addNewItemCancelHandler}
            />
          )}
          {!!exams.length &&
            exams.map((exam) => (
              <UpcomingExamsCard
                key={exam._id}
                userId={userId}
                exam={exam}
                onDeleteEntry={deleteEntryHandler}
              />
            ))}
          {!isAddNewItem && !exams.length && !isMentorViewer && (
            <StepBanner
              stepOption={'missingExams'}
              onClick={() => setIsAddNewItem((prev) => !prev)}
            />
          )}
        </>
      )}
    </ProfileMainSection>
  );
};

export default UpcomingExamsSection;
